import { render, staticRenderFns } from "./userCoinLine.vue?vue&type=template&id=4e38bfec&scoped=true&"
import script from "./userCoinLine.vue?vue&type=script&scoped=true&lang=js&"
export * from "./userCoinLine.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./userCoinLine.vue?vue&type=style&index=0&id=4e38bfec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e38bfec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e38bfec')) {
      api.createRecord('4e38bfec', component.options)
    } else {
      api.reload('4e38bfec', component.options)
    }
    module.hot.accept("./userCoinLine.vue?vue&type=template&id=4e38bfec&scoped=true&", function () {
      api.rerender('4e38bfec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/components/userCoinLine.vue"
export default component.exports